import { createField, updateField } from '../../actions';
import { EVENT_STEP_VALIDATE, PAYMENT_TYPE_SEPA } from '../../helpers/consts';

export class PaymentRadioGroupField {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.radioButtons = options.radioButtons;
        this.id = options.id;
        this.label = options.label;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id);
        this.value = (fieldState && fieldState.value) ? fieldState.value : `radio-${PAYMENT_TYPE_SEPA}`;
        this.isValid = (fieldState && fieldState.valid) ? fieldState.valid : false;
        this.$el = this.createFieldElement();

        if (this.value !== '') {
            this.checkedId = this.value;
            this.validate();
        }
    }

    createFieldElement () { // eslint-disable-line class-methods-use-this
        const $radioGroup = document.createElement('div');
        $radioGroup.classList.add('field-group', 'field-group--radio-big');

        for (const radioButton of this.radioButtons) {
            const $field = document.createElement('div');
            const $fieldLabel = document.createElement('label');
            const $fieldInput = document.createElement('input');

            $fieldInput.type = 'radio';
            $fieldInput.name = this.id;
            $fieldInput.checked = this.id === PAYMENT_TYPE_SEPA;
            $fieldInput.id = `radio-${radioButton.id}`;
            $fieldInput.checked = ($fieldInput.id === this.value) || (radioButton.id === PAYMENT_TYPE_SEPA);

            $fieldLabel.setAttribute('for', `radio-${radioButton.id}`);
            $fieldLabel.innerHTML = radioButton.label;

            $field.classList.add('field', 'field--radio-big', `field--radio-big-${radioButton.id.toLowerCase()}`);
            $fieldLabel.classList.add('field-label');
            $fieldInput.classList.add('visually-hidden');

            $field.appendChild($fieldInput);
            $field.appendChild($fieldLabel);

            $radioGroup.appendChild($field);

            $fieldInput.addEventListener('change', this.validate.bind(this));
        }

        this.store.dispatch(createField(this.id, this.label, this.stepId));

        return $radioGroup;
    }

    validate(e) {
        let inputField = null;

        if (e) {
            inputField = e.target.tagName.toUpperCase() === 'INPUT' ? e.target : null;
            this.checkedId = inputField ?  e.target.id : e.target.getAttribute('for');
            this.value = this.checkedId;
        }
        this.isValid = this.checkedId !== null;
        this.store.dispatch(updateField(this.id, this.value, this.isValid, this.label));
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default PaymentRadioGroupField;
